<template>
    <base-modal @close="$emit('close', $event)">
        <header class="save-modal__header">
            <h2 class="save-modal__title">
                <slot name="title"></slot>
            </h2>
        </header>

        <div class="save-modal__body">
            <slot name="body"></slot>
        </div>

        <footer class="save-modal__footer">
            <button
                class="save-modal__btn save-modal__btn--cancel"
                @click="$emit('cancel')"
            >
                Cancel
            </button>

            <button
                class="save-modal__btn save-modal__btn--confirm"
                @click="$emit('confirm')"
            >
                Continue
            </button>
        </footer>
    </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue'

export default {
    components: {
        BaseModal,
    },
}
</script>

<style scoped>
.save-modal__header {
    border-bottom: 0.5px solid #636a6d;
    width: 100%;
    padding-bottom: 10px;
    font-size: 1.25rem;
}

.save-modal__body {
    font-size: 14px;
    padding: 10px 0 10px 0;
}

.save-modal__footer {
    display: flex;
    justify-content: space-between;
}

.save-modal__btn {
    padding: 7px 20px;
    border-radius: 8px;
    border: none;
    color: #ffffff;
    cursor: pointer;
    font-size: 1rem;
}

.save-modal__btn--cancel {
    background-color: #434a4d;
}

.save-modal__btn--confirm {
    background-color: #2196f3;
}
</style>
